module.exports = __webpack_public_path__ + "img/sign-in.857c8105.svg";